'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';

export const inbodyModule = angular
  .module('app.inbody', [])
  .config(inbodyConfig);

inbodyConfig.$inject = ['$routeProvider'];

function inbodyConfig($routeProvider) {
  $routeProvider
    .when('/inbody-keys', {
      template: '<ngz-inbody-keys></ngz-inbody-keys>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'InBody Keys', icon: NAVIGATION_ICON.KEY }
        ]
      }
    })
}
